import { Box, Button, TextField, Typography } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

export default function Comments() {
   const dispatch = useDispatch();
   const state = useSelector((store) => store.cgpgApproval);
   const {productGroupsTable,customerGroupTable,productGroups,customerGroups,groupRowClicked,clickedRowComment}=state;
   return (
      groupRowClicked && (
      <Box sx={{ mt: 2 }}>
         <div>
            <Typography variant="p14w700" gutterBottom>
               Comments
            </Typography> 
         </div>

         <div>
            <TextField className={'fullWidth'}
               size="large"
               multiline
               rows={6}
               style={{overflowY:'auto'}}
               disabled
               value={clickedRowComment}
            />
         </div>
      </Box>
      )
   );
}
